import './Text.scss';

export interface TextProps {
  /**
   * Text size
   */
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl';
  /**
   * Font weight
   */
  weight?: 'light' | 'normal' | 'medium' | 'semibold' | 'bold';
  /**
   * Color variant
   */
  color?: 'primary' | 'secondary' | 'muted' | 'error' | 'success';
  /**
   * Content
   */
  children: React.ReactNode;
  /**
   * HTML element to render as
   */
  as?: keyof React.JSX.IntrinsicElements;
  /**
   * Additional class name
   */
  className?: string;
}

/**
 * Body text component with design token typography
 */
export function Text({
  size = 'base',
  weight = 'normal',
  color = 'primary',
  children,
  as: Component = 'p',
  className,
}: TextProps) {
  const classes = [
    'text',
    `text-size-${size}`,
    `text-weight-${weight}`,
    `text-color-${color}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <Component className={classes}>{children}</Component>;
}
